export const LOCAL_STORAGE_KEY = {
  settingDialog: 'settingDialog',
  settingDialogHeaders: 'headers',
  settingDialogSortConfig: 'sortConfig',
  settingDialogShortTime: 'shortTime',
  settingDialogFunctionalTraining: 'functionalTraining',
  blockAndUnitData: 'blockAndUnitData',
  groupData: 'groupData',
  settingExcreationDiaglog:'settingExcreationDiaglog',
  marqueeSpeedRate: 'marqueeSpeedRate',
  corpPrefix: 'corp_prefix',
  enCorpPrefix: 'en_corp_prefix',
  corpPrefixOld: 'corp_prefix_old',
  screen: 'screen',
  mode: 'mode',
  corpData: 'corp_data',
  custSession: 'cust_session',
  tvLoginSession: 'tv_login_session',
  tvDeviceNameRegistered: 'tv_device_name_registered',
  nyuShoDisplayConfig: 'nyuShoDisplayConfig',
  functionalTraining: 'functionalTraining',
  shortTime:'shortTime',
  sortConfig:'sortConfig',
  saucerLogs: 'saucerLogs',
};

export const SESSION_STORAGE_KEY = {
  loginSession: 'login_session',
  officeSelected: 'officeSelected',
  deviceToken: 'deviceToken',
  staffInfo: 'staff_inf', // cho login
  daiInfo: 'dai_inf', // cho user là bệnh nhân
  corpPrefix: 'corp_prefix',
  selectedOfficeIdentity: 'selected_office_identity',
  staffCd: 'staffCd',
  topicName: 'topicName',
  detailData: 'detailData',
  remoteReloadScreen: 'remote_reload_screen',
  // Set by web 1.17.0+ (saves the screen on a remote Reload) at TV startup; see TvStartupService.
  sinceWebVer1170: 'since_webver_1_17_0',
  firebaseToken: 'firebaseToken',
  lastSyncDate: 'last_sync_date',
  WEB_APP_VERSION: 'WebAppVersion',
  sessionsFBId: 'sessionsFBId',
  corpCd:'corpCd',
  FORCE_LOGOUT_VERSION: 'forceLogoutVersion',
  FORCE_SYNC_MASTER_VERSION: 'forceSyncMasterVersion',
  validSchedulePeriod: 'valid_schedule_period',
  ckDataChangedByDevice: 'ckDataChangedByDevice',
  pendingDeviceLogs: 'pending_device_logs',
  loginDateTime: 'login_date_time',
  syncVersionAfterReload: 'sync_version_after_reload',
};
